import { Link } from 'react-router-dom'
import { Wrench, Sprout, Palette } from 'lucide-react'
import { useMemo } from 'react'
import { useI18n } from '../i18n/I18nProvider'

function Shop() {
  const { t, messages } = useI18n()
  const merchants = useMemo(() => ([
    {
      id: 'tools',
      name: t('shop.merchants.tools.name'),
      description: t('shop.merchants.tools.description'),
      icon: Wrench,
      color: 'from-orange-500 to-orange-600',
    },
    {
      id: 'seeds',
      name: t('shop.merchants.seeds.name'),
      description: t('shop.merchants.seeds.description'),
      icon: Sprout,
      color: 'from-green-500 to-green-600',
    },
    {
      id: 'cosmetics',
      name: t('shop.merchants.cosmetics.name'),
      description: t('shop.merchants.cosmetics.description'),
      icon: Palette,
      color: 'from-purple-500 to-purple-600',
    },
  ]), [t])

  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-4xl font-bold text-green-800 mb-4 text-center">
          {t('shop.title')}
        </h1>
        <p className="text-gray-600 text-center mb-12">
          {t('shop.subtitle')}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {merchants.map((merchant) => {
            const Icon = merchant.icon
            return (
              <Link
                key={merchant.id}
                to={`/shop/${merchant.id}`}
                className="group"
              >
                <div className="bg-white rounded-xl shadow-lg overflow-hidden transition-transform duration-300 hover:scale-105 hover:shadow-2xl">
                  <div className={`bg-gradient-to-r ${merchant.color} p-8 flex items-center justify-center`}>
                    <Icon size={80} className="text-white" />
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      {merchant.name}
                    </h3>
                    <p className="text-gray-600">
                      {merchant.description}
                    </p>
                  </div>
                </div>
              </Link>
            )
          })}
        </div>

        {/* Subscription Section */}
        <div className="mt-16">
          <h2 className="text-3xl font-bold text-green-800 mb-8 text-center">
            {t('shop.subscriptionsTitle')}
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {['basic', 'standard', 'premium'].map((planKey, index) => {
              const plan = messages?.shop?.plans?.[planKey]
              if (!plan) return null
              const colors = ['border-green-300', 'border-green-500', 'border-green-700']
              const popular = planKey === 'standard'
              return (
                <div
                  key={plan.name}
                  className={`bg-white rounded-xl shadow-lg p-8 border-4 ${colors[index]} relative`}
                >
                  {popular && (
                    <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                      <span className="bg-green-500 text-white px-4 py-1 rounded-full text-sm font-bold">
                        {t('shop.popular')}
                      </span>
                    </div>
                  )}
                  <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center">
                    {plan.name}
                  </h3>
                  <div className="text-4xl font-bold text-green-600 mb-4 text-center">
                    {plan.price}
                    <span className="text-lg text-gray-600">{t('shop.perMonth')}</span>
                  </div>
                  <p className="text-gray-600 text-center mb-6">
                    {t('shop.autoGrowthLabel')} {plan.clicks}
                  </p>
                  <button className="w-full bg-green-600 text-white py-3 rounded-lg font-bold hover:bg-green-700 transition">
                    {t('shop.subscribe')}
                  </button>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Shop
